<template>
  <h1
      class="page-header"
      :class="{ 'page-header--gradient': gradient }"
  >
    <slot/>
  </h1>
</template>

<script>
export default {
  props: {
    gradient: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/styling.scss";
@import "@/assets/css/mixins/breakpoints-up.scss";

.page-header {
  @include gradient-text;
  font-size:   3.2rem;
  line-height: 3rem;
  letter-spacing: -0.1rem;

  @include lg-down {
    padding: 1rem 0;
  }

  @include xl-up {
    font-size: 4rem;
    line-height: 3.8rem;
  }

  @include xxl-up {
    font-size:   4.2rem;
    line-height: 4rem;
    letter-spacing: -0.1rem;
  }

  @include xxxl-up {
    font-size:   4.8rem;
    line-height: 5rem;
    letter-spacing: -0.1rem;
  }
}
</style>